var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.16878 24.4908C0.995088 24.4908 0.0347947 23.542 0.0347947 22.3825C0.0347947 21.8027 0.248194 21.2756 0.674991 20.8539L9.74443 12.2626L0.674991 3.67121C-0.178604 2.8806 -0.231954 1.5629 0.568291 0.66687C1.36854 -0.176455 2.70228 -0.229163 3.60922 0.561454L3.66257 0.614162L14.3325 10.7341C15.1861 11.5247 15.2394 12.8951 14.3859 13.7384L14.3325 13.7911L3.66257 23.8583C3.23577 24.2272 2.70228 24.4381 2.16878 24.4908Z",
    fill: "#009AFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBtn);
export default __webpack_public_path__ + "static/media/chevronBtn.4b2a4831bfe91dbf641687a31f5c8904.svg";
export { ForwardRef as ReactComponent };